module.exports = __webpack_public_path__ + "static/media/o.d34b660e.svg";